import { AnimationType } from './sprite-types';
export default [
    {
        name: '无',
        type: AnimationType.none,
        frames: []
    },
    {
        name: '自定义动画',
        type: AnimationType.custom,
        frames: []
    },
    {
        name: '左右跳动', //动画名称
        type: AnimationType.leftRight, //动画类型
        // 动画的关键帧
        frames: [
            {
                duration: 100,
                x: 0,
            },
            {
                duration: 1000,
                x: 20,
            },
            {
                duration: 100,
                x: 0,
            },
            {
                duration: 1000,
                x: -20,
            }
        ]
    },
    {
        name: '上下跳动',
        type: AnimationType.upDown,
        frames: [
            {
                duration: 1000,
                y: 20,
            },
            {
                duration: 1000,
                y: -20,
            }
        ]
    },
    {
        name: '旋转',
        type: AnimationType.rotate,
        frames: [
            {
                duration: 1000,
                rotate: 720
            }
        ]
    },
    {
        name: '成功',
        type: AnimationType.sucess,
        frames: [
            {
                duration: 1000,
                background: '#008585'
            }
        ]
    },
    {
        name: '错误',
        type: AnimationType.error,
        frames: [
            {
                duration: 1000,
                background: '#cc6666'
            }
        ]
    },
]